/**
 * Lightweight logger utility for development/production environments
 * Replaces scattered console.log statements with structured logging
 */

const isDev = import.meta.env.DEV;

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LogContext {
  [key: string]: unknown;
}

const formatMessage = (prefix: string, message: string): string => {
  return `[${prefix}] ${message}`;
};

export const logger = {
  /**
   * Debug-level logging (development only)
   */
  debug: (prefix: string, message: string, context?: LogContext): void => {
    if (isDev) {
      console.log(formatMessage(prefix, message), context ?? '');
    }
  },

  /**
   * Info-level logging (development only)
   */
  info: (prefix: string, message: string, context?: LogContext): void => {
    if (isDev) {
      console.info(formatMessage(prefix, message), context ?? '');
    }
  },

  /**
   * Warning-level logging (always visible)
   */
  warn: (prefix: string, message: string, context?: LogContext): void => {
    console.warn(formatMessage(prefix, message), context ?? '');
  },

  /**
   * Error-level logging (always visible)
   */
  error: (prefix: string, message: string, context?: LogContext): void => {
    console.error(formatMessage(prefix, message), context ?? '');
  },
};

export default logger;
